import { render, staticRenderFns } from "./OtherV4.vue?vue&type=template&id=41866dc2&"
import script from "./OtherV4.vue?vue&type=script&lang=ts&"
export * from "./OtherV4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports